import * as home from './home';
import * as request from './request';
import * as sns from './sns';
import * as uiTool from './ui-tool';
import * as customer from './customer';
import * as postcode from './postcode';
import * as realtime from './realtime';
import * as status from './status';
import form from './form';
import partials from './partials';

export default {
  home,
  request,
  sns,
  customer,
  uiTool,
  postcode,
  realtime,
  status,
  partials,
  form,
};
